import _ from 'lodash';
import ERRORS_TAB from '../../models/errorsTab.js';
import ORCHESTRATION_ERRORS_TAB from '../../models/orchestrationErrorTab';
import CONNECTED_ERRORS_TAB from '../../models/connectedErrorTab';

const completedStatus = 'COMPLETE';
const failedStatus = 'FAILED';
const DATA_MISMATCH_CODE = ['F006','F014','C041'];
const EXTRACT_STATUS_COMPLETE = 'COMPLETE';

class BatchErrorsController {
  constructor(extractsService, sourceErrorsService, statusIndicatorService, orchestrationErrorService, config, batchService, $state) {
    this.name = 'errors';
    this.tab = ERRORS_TAB;
    this.options = this.tab.options;
    this.hasErrors = false;
    this.extractsService = extractsService;
    this.orchestrationTab = ORCHESTRATION_ERRORS_TAB;
    this.orchestrationErrorService = orchestrationErrorService;
    this.sourceErrorsService = sourceErrorsService;
    this.statusIndicatorService = statusIndicatorService;
    this.isCheckingForErrors = false;
    this.hasOrchestrationError = false;
    this.hasImportThresholdErrors = false;
    this.config = config;
    this.batchService = batchService;
    this.$state = $state;

    this.offset = 0;
    this.ROWS_PER_PAGE = 100;
    this.previousData = {
      content: []
    };

    this.checkBatchStatus();
  }


  checkBatchStatus() {
    this.statusIndicatorService.getStatus().then(this.onStatusRecieved.bind(this));
  }

  onStatusRecieved(response) {
    let status = response.data.content ? response.data.content.status : null;
    this.batchId = response.data.content ? response.data.content.id : null;
    this.batchStatus = status;
    this.customerId = response.data.content ? response.data.content.customerId : null;

    if (this.customerId ) {
      this.checkForOrchestrationLog(this.customerId );
    }

    if (status === completedStatus || status === failedStatus) {
      this.checkForErrors();
    }
  }

  getNextSetOfRowsToFetch() {
    this.checkForOrchestrationLog(this.customerId);
  }

  checkForOrchestrationLog(customerId){
    this.orchestrationErrorService.getErrors(customerId, this.offset, this.ROWS_PER_PAGE).then(this.onOrchestrationErrorSucess.bind(this));
  }

  onOrchestrationErrorSucess(response){
    const orchestrationLog = response.data;
    if (orchestrationLog.length > 0) {
      this.hasOrchestrationError = true;

      //need to create a new object with content key as table component needs it.
      this.orchestrationErrorData = {
        content : this.previousData.content.concat(orchestrationLog)
      };

      this.previousData = this.orchestrationErrorData;
      this.offset += this.ROWS_PER_PAGE;
    }

  }

  checkForErrors() {
    this.isCheckingForErrors = true;
    this.sourceErrorsService.getErrors().then(this.onErrorsRecieved.bind(this));
  }

  onErrorsRecieved(response) {
    this.isCheckingForErrors = false;
    let errors = response.data.content.filter(item => item.level !== 4);

    if (errors.length > 0) {
      this.hasErrors = true;
      this.hasImportThresholdErrors = _.some(response.data.content, (item) => DATA_MISMATCH_CODE.includes(item.code));
      this.alertSeverityFlag = _.some(response.data.content, (item) => {
        return (item.level === 1 || item.level === 2);
      }) ? 'danger' : 'warning';
    }
  }

  hasBatchCompletedWithoutErrors() {
    if(!this.isCheckingForErrors) {
      return this.hasBatchCompleted() &&  !this.hasBatchErrors();
    }
  }

  hasBatchFailedWithoutErrors() {
    if(!this.isCheckingForErrors) {
      return this.hasBatchFailed() &&  !this.hasBatchErrors();
    }
  }

  hasBatchCompletedOrFailedWithErrors() {
    return (this.hasBatchCompleted() || this.hasBatchFailed()) &&  this.hasBatchErrors();
  }

  hasBatchCompletedOrFailedWithoutErrors() {
    return this.hasBatchCompletedWithoutErrors() || this.hasBatchFailedWithoutErrors();
  }

  hasBatchErrors() {
    return this.hasErrors;
  }

  hasInvalidBatchStatus() {
    if(!this.isCheckingForErrors) {
      return this.batchStatus === null || typeof(batchStatus) === undefined ;
    }
  }

  hasBatchCompleted() {
    return this.batchStatus === completedStatus;
  }

  hasBatchFailed() {
    return this.batchStatus === failedStatus;
  }

  cancelThresholdError(){
    this.hasImportThresholdErrors = false;
  }

  reSubmitBatchWithForceOverride(){
    const batch = {
      id : this.batchId,
      force: 1
    };
    this.batchService.updateBatch(batch)
      .then(()=>{
        this.$state.reload();
        this.checkBatchStatus();
      });
  }
}

BatchErrorsController.$inject = ['extractsService', 'sourceErrorsService', 'statusIndicatorService', 'orchestrationErrorService', 'config', 'batchService', '$state'];

export
default BatchErrorsController;



// WEBPACK FOOTER //
// ./app/components/batchErrors/batchErrors.controller.js